export default __webpack_public_path__ + "static/media/care-for-life.a5a0d6a0.jpg";